<template>
  <div>
    <ul
      class="tw-flex tw-w-max tw-cursor-pointer tw-rounded-full tw-bg-neutral-50 tw-p-0.5 tw-text-xs"
      :class="listClasses"
    >
      <li v-for="tab in tabs" :key="tab.id">
        <button
          @click="selectTab(tab.id)"
          class="tw-rounded-full tw-px-3 tw-py-1 tw-font-semibold tw-antialiased focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-secondary-500 focus-visible:tw-ring-offset-0"
          :class="[
            isTabSelected(tab.id)
              ? 'tw-bg-white tw-text-neutral-900'
              : 'tw-text-neutral-500',
          ]"
        >
          {{ tab.title }}
        </button>
      </li>
    </ul>
    <div ref="slotsRef">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { onMounted, provide, ref } from 'vue'

defineProps({
  listClasses: {
    type: String,
    default: '',
  },
})

const slotsRef = ref(null)

const tabs = ref([])
const activeTab = ref(null)
provide('activeTab', activeTab)

const selectTab = (id) => {
  activeTab.value = tabs.value.find((tab) => tab.id === id)
}

const isTabSelected = (id) => {
  return activeTab.value.id === id
}

onMounted(() => {
  tabs.value = Array.from(slotsRef.value.children)
    .filter((element) => {
      const componentName = element.getAttribute('data-component-name')
      return componentName === 'ExpertiseTab'
    })
    .map((element) => ({
      id: element.id,
      title: element.getAttribute('data-title'),
    }))

  activeTab.value = tabs.value[0]
})
</script>
